import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ImportOutlinedSvg from "@ant-design/icons-svg/es/asn/ImportOutlined";
import AntdIcon from '../components/AntdIcon';
var ImportOutlined = function ImportOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: ImportOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(ImportOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ImportOutlined';
}
export default RefIcon;